module.exports = __webpack_public_path__ + "static/media/banner-four.9181943b.png";